import { render, staticRenderFns } from "./OrganizationInsightComponent.vue?vue&type=template&id=22880362&"
import script from "./OrganizationInsightComponent.vue?vue&type=script&lang=ts&"
export * from "./OrganizationInsightComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22880362')) {
      api.createRecord('22880362', component.options)
    } else {
      api.reload('22880362', component.options)
    }
    module.hot.accept("./OrganizationInsightComponent.vue?vue&type=template&id=22880362&", function () {
      api.rerender('22880362', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/views/admin/organization/insights/OrganizationInsightComponent.vue"
export default component.exports